import React from "react";

export const Marketing = () => {
  return (
    <div className="leading-relaxed text-[#333] max-w-[900px] mx-auto p-5 bg-white min-h-screen box-border">
      <h1 className="text-[#1890ff] border-b-2 border-[#1890ff] pb-[10px] mt-0 text-[2rem] font-bold">
        SurfingCre Marketing Consent / 마케팅 수신 동의
      </h1>

      <h2 className="mt-[30px] border-b border-[#e8e8e8] pb-[5px] text-[1.5rem] font-semibold">
        서핑크리(SurfingCre) 마케팅 정보 수신 동의서 — 한국어
      </h2>
      <p className="my-[10px] text-[1.4rem]">
        주식회사 금바다(이하 "회사")는 서핑크리 플랫폼 이용자에게 맞춤형 혜택 및
        정보를 제공하기 위해 아래와 같이 마케팅 정보의 수집·이용에 대해 동의를
        받고자 합니다. 본 동의는 선택 사항이며, 동의하지 않더라도 서비스
        이용에는 제한이 없습니다.
      </p>

      <h2 className="mt-[30px] border-b border-[#e8e8e8] pb-[5px] text-[1.5rem] font-semibold">
        1. 수집·이용 항목
      </h2>
      <ul className="my-[10px] pl-[30px] list-disc">
        <li className="my-[5px] text-[1.4rem]">이름</li>
        <li className="my-[5px] text-[1.4rem]">생년월일(생일)</li>
        <li className="my-[5px] text-[1.4rem]">주소</li>
        <li className="my-[5px] text-[1.4rem]">전화번호(휴대전화 포함)</li>
        <li className="my-[5px] text-[1.4rem]">국가</li>
        <li className="my-[5px] text-[1.4rem]">업종</li>
        <li className="my-[5px] text-[1.4rem]">
          (브랜드 회원의 경우) 사업자등록번호
        </li>
      </ul>

      <h2 className="mt-[30px] border-b border-[#e8e8e8] pb-[5px] text-[1.5rem] font-semibold">
        2. 이용 목적
      </h2>
      <ul className="my-[10px] pl-[30px] list-disc">
        <li className="my-[5px] text-[1.4rem]">
          신규 서비스·기능 안내 및 플랫폼 공지
        </li>
        <li className="my-[5px] text-[1.4rem]">
          이벤트·프로모션·할인 정보 제공
        </li>
        <li className="my-[5px] text-[1.4rem]">
          브랜드–크리에이터 매칭을 위한 맞춤 추천
        </li>
        <li className="my-[5px] text-[1.4rem]">뉴스레터 및 시장 리포트 발송</li>
        <li className="my-[5px] text-[1.4rem]">
          캠페인 참여 유도 및 재참여 안내
        </li>
      </ul>

      <h2 className="mt-[30px] border-b border-[#e8e8e8] pb-[5px] text-[1.5rem] font-semibold">
        3. 보유 및 이용 기간
      </h2>
      <ul className="my-[10px] pl-[30px] list-disc">
        <li className="my-[5px] text-[1.4rem]">
          마케팅 수신 동의 철회 시까지 보유 및 이용합니다.
        </li>
        <li className="my-[5px] text-[1.4rem]">
          동의 철회 시 회사는 해당 마케팅 목적 정보의 이용을 즉시 중단하고 관련
          정보를 삭제합니다.
        </li>
      </ul>

      <h2 className="mt-[30px] border-b border-[#e8e8e8] pb-[5px] text-[1.5rem] font-semibold">
        4. 수신 거부 및 철회 방법
      </h2>
      <ul className="my-[10px] pl-[30px] list-disc">
        <li className="my-[5px] text-[1.4rem]">
          서비스 내 계정 설정(알림/수신 설정)에서 직접 변경
        </li>
        <li className="my-[5px] text-[1.4rem]">
          수신된 이메일/문자 내 '수신거부' 링크 클릭
        </li>
        <li className="my-[5px] text-[1.4rem]">
          고객센터 문의(문의 페이지 또는 support@surfingcre.co.kr)
        </li>
      </ul>

      <h2 className="mt-[30px] border-b border-[#e8e8e8] pb-[5px] text-[1.5rem] font-semibold">
        5. 선택적 동의 안내
      </h2>
      <ul className="my-[10px] pl-[30px] list-disc">
        <li className="my-[5px] text-[1.4rem]">
          본 동의는 선택적이며, 미동의 시에도 기본 서비스 이용에는 영향이
          없습니다.
        </li>
      </ul>

      <p className="my-[10px] text-[1.4rem]">작성일: 2025-11-21</p>

      <p className="my-[10px] text-[1.4rem]">
        주식회사 금바다 / 서핑크리 운영팀
      </p>

      <h2 className="mt-[50px] border-b border-[#e8e8e8] pb-[5px] text-[1.5rem] font-semibold">
        SurfingCre Marketing Communication Consent — English
      </h2>

      <p className="my-[10px] text-[1.4rem]">
        Company: Geumbada Co., Ltd. (주식회사 금바다) — Platform: SurfingCre
      </p>
      <p className="my-[10px] text-[1.4rem]">
        Geumbada Co., Ltd. ("Company") requests your consent to collect and use
        personal data for marketing purposes to provide tailored offers, updates
        and promotional information. Consent is voluntary and will not affect
        your right to use the basic services.
      </p>

      <h2 className="mt-[30px] border-b border-[#e8e8e8] pb-[5px] text-[1.5rem] font-semibold">
        1. Collected Information
      </h2>
      <ul className="my-[10px] pl-[30px] list-disc">
        <li className="my-[5px] text-[1.4rem]">Full name</li>
        <li className="my-[5px] text-[1.4rem]">Date of birth</li>
        <li className="my-[5px] text-[1.4rem]">Address</li>
        <li className="my-[5px] text-[1.4rem]">
          Phone number (including mobile)
        </li>
        <li className="my-[5px] text-[1.4rem]">Country</li>
        <li className="my-[5px] text-[1.4rem]">Industry</li>
        <li className="my-[5px] text-[1.4rem]">
          (For Brand members) Business registration number
        </li>
      </ul>

      <h2 className="mt-[30px] border-b border-[#e8e8e8] pb-[5px] text-[1.5rem] font-semibold">
        2. Purpose of Use
      </h2>
      <ul className="my-[10px] pl-[30px] list-disc">
        <li className="my-[5px] text-[1.4rem]">
          Service updates and platform announcements
        </li>
        <li className="my-[5px] text-[1.4rem]">
          Event, promotion, and discount notifications
        </li>
        <li className="my-[5px] text-[1.4rem]">
          Personalized brand–creator matching recommendations
        </li>
        <li className="my-[5px] text-[1.4rem]">
          Newsletters and market reports
        </li>
        <li className="my-[5px] text-[1.4rem]">
          Campaign participation invitations and re-engagement communications
        </li>
      </ul>

      <h2 className="mt-[30px] border-b border-[#e8e8e8] pb-[5px] text-[1.5rem] font-semibold">
        3. Retention Period
      </h2>
      <ul className="my-[10px] pl-[30px] list-disc">
        <li className="my-[5px] text-[1.4rem]">
          We retain marketing consent information until you withdraw your
          consent.
        </li>
        <li className="my-[5px] text-[1.4rem]">
          Upon withdrawal, the Company will cease marketing use and delete
          related marketing information promptly.
        </li>
      </ul>

      <h2 className="mt-[30px] border-b border-[#e8e8e8] pb-[5px] text-[1.5rem] font-semibold">
        4. How to Withdraw Consent / Opt-Out
      </h2>
      <ul className="my-[10px] pl-[30px] list-disc">
        <li className="my-[5px] text-[1.4rem]">
          Change settings in your account (Notifications / Communication
          Preferences)
        </li>
        <li className="my-[5px] text-[1.4rem]">
          Click 'unsubscribe' in received emails/SMS
        </li>
        <li className="my-[5px] text-[1.4rem]">
          Contact Customer Support (support@surfingcre.co.kr)
        </li>
      </ul>

      <h2 className="mt-[30px] border-b border-[#e8e8e8] pb-[5px] text-[1.5rem] font-semibold">
        5. Voluntary Consent Notice
      </h2>
      <ul className="my-[10px] pl-[30px] list-disc">
        <li className="my-[5px] text-[1.4rem]">
          This consent is optional. Declining will not restrict access to core
          services.
        </li>
      </ul>

      <p className="my-[10px] text-[1.4rem]">Date Issued: 2025-11-21</p>

      <p className="my-[10px] text-[1.4rem]">
        Geumbada Co., Ltd. / SurfingCre Operations Team
      </p>
    </div>
  );
};
